<template>
  <p class="donation-paragraph">
    Wist u dat doneren aan ons voor u fiscale voordelen heeft? Meer weten,
    <span @click="redirect" class="link-4">klik dan hier</span> 1% van het drempel inkomen
    kan afschrikken omdat mensen vaak al niet weten wat het drempel inkomen is
  </p>
</template>

<script>
export default {
  methods: {
    redirect() {
      window.location.href = "/donatie"
    },
  },
}
</script>

<style scoped>
.link-4 {
  cursor: pointer;
}
</style>
